/**
 * Factory pour créer le bon adapter de balance
 * selon la configuration du tenant et les capacités du navigateur
 */

import { ScaleAdapter, ScaleConfig } from './ScaleAdapter';
import { BaxtranSLAdapter } from './BaxtranSLAdapter';
import { ManualScaleAdapter } from './ManualScaleAdapter';
import { WebSocketScaleAdapter } from './WebSocketScaleAdapter';
import { logger } from '../../utils/logger';

export class ScaleAdapterFactory {
  /**
   * Créer un adapter de balance selon la configuration
   */
  static create(config: ScaleConfig): ScaleAdapter {
    switch (config.model) {
      case 'BAXTRAN_SL':
        // Si Web Serial API n'est pas supporté (Safari, Firefox), utiliser WebSocket
        if (!this.isWebSerialSupported()) {
          logger.log('[ScaleAdapterFactory] Web Serial API non supporté, utilisation de WebSocket');
          // Pas de défaut hardcodé — si config.port est vide, le bridge utilisera
          // sa propre config locale (config.scale.port) qui contient le bon chemin macOS
          return new WebSocketScaleAdapter(config.port);
        }
        return new BaxtranSLAdapter();

      case 'MANUAL':
        return new ManualScaleAdapter();

      // Futurs adapters
      case 'BIZERBA':
        logger.warn('Adapter BIZERBA non implémenté, utilisation du mode manuel');
        return new ManualScaleAdapter();

      case 'METTLER_TOLEDO':
        logger.warn('Adapter METTLER_TOLEDO non implémenté, utilisation du mode manuel');
        return new ManualScaleAdapter();

      default:
        logger.warn(`Modèle de balance inconnu: ${config.model}, utilisation du mode manuel`);
        return new ManualScaleAdapter();
    }
  }

  /**
   * Vérifier si Web Serial API est supporté
   */
  static isWebSerialSupported(): boolean {
    return 'serial' in navigator;
  }

  /**
   * Détecter si le navigateur est Safari
   */
  static isSafari(): boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  /**
   * Obtenir la liste des modèles supportés
   */
  static getSupportedModels(): Array<ScaleConfig['model']> {
    return ['BAXTRAN_SL', 'MANUAL', 'BIZERBA', 'METTLER_TOLEDO'];
  }
}
